import { ButtonHTMLAttributes  } from "react"

const IconButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
    return <button className="icon-button" {...props}/>
}

export default IconButton